import React from "react";

import Detail from "../Detail/Detail";
import Button, {
  buttonTypes,
  actionTypes
} from "@bit/fabfitfun.shared.global.button";

import env from "../../../utils/env";

const ReferAFriend = props => {
  const { title, desc, cta } = props;

  return (
    <Detail icon={"fa-money-bill-wave"} title={title} description={desc}>
      <br />
      <Button
        type={buttonTypes.PRIMARY.value}
        action={actionTypes.CALL_TO_ACTION.value}
        label={cta}
        style={{ width: "100%" }}
        onClick={() => {
          window.location = `${env.envURL}/invite/`;
        }}
      />
    </Detail>
  );
};

export default ReferAFriend;



// WEBPACK FOOTER //
// ./src/Components/Header/ReferAFriend/ReferAFriend.js